module.exports = __webpack_public_path__ + "img/image1.27d15fc.webp";